var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 22q-1.275 0-2.5-.35T8.2 20.6l1.45-1.45q.775.425 1.625.638Q12.125 20 13 20q2.925 0 4.962-2.038Q20 15.925 20 13t-2.038-4.963Q15.925 6 13 6h-.15l1.55 1.55L13 9 9 5l4-4 1.4 1.45L12.85 4H13q3.75 0 6.375 2.625T22 13q0 1.875-.712 3.512-.713 1.638-1.925 2.85-1.213 1.213-2.85 1.926Q14.875 22 13 22Zm-6-3-6-6 6-6 6 6Zm0-2.85L10.15 13 7 9.85 3.85 13ZM7 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate_right.df4ffe25b03f49fc673a0924436244e0.svg";
export { ForwardRef as ReactComponent };